import {
  getDateRangeAsString,
  relativeDateToDateRange,
} from "../../utils/date";

import InfoIcon from "../icons/InfoIcon";
import { ReactNode } from "react";
import { RelativeDate } from "../../types";
import classNames from "classnames";
import css from "./AudienceComparisonLabel.module.css";

type AudienceComparisonLabelProps = {
  audience: ReactNode;
  baseline: ReactNode;
  audienceWeighting?: string;
  dateFilter: RelativeDate;
  className?: string;
};

/**
 * Renders a pill-style label describing the provided filters.
 */
const AudienceComparisonLabel = ({
  audience,
  baseline,
  audienceWeighting,
  dateFilter,
  className,
}: AudienceComparisonLabelProps) => {
  const audienceWeightingStr = audienceWeighting ? "weighted " : "";
  return (
    <div
      className={classNames(
        css["audience-comparison-label"],
        "badge rounded-pill",
        className,
      )}
    >
      <InfoIcon />
      <span>
        All respondents in {audienceWeightingStr}
        <strong>{audience}</strong> compared against weighted baseline{" "}
        <strong>{baseline}</strong>{" "}
        {getDateRangeAsString(relativeDateToDateRange(dateFilter))}
      </span>
    </div>
  );
};

export default AudienceComparisonLabel;
